import { Redirect, Route, useRouteMatch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import ParentWrapper from "../../components/ParentWrapper";
import PrivateRoute from "../../components/PrivateRoute";

import BioSpecimenAccessProgram from "../SampleDistribution/ShipmentInquiries";

const queryClient = new QueryClient();

const ParentConsole = () => {
  let { path } = useRouteMatch();
  return (
    <QueryClientProvider client={queryClient}>
      <ParentWrapper path={path}>
        <PrivateRoute exact path={`${path}/shipment-inquiries`}>
          <BioSpecimenAccessProgram />
        </PrivateRoute>
        <Route>
          <Redirect to={`${path}/shipment-inquiries`} />
        </Route>
      </ParentWrapper>
    </QueryClientProvider>
  );
};

export default ParentConsole;
